import { Tooltip as MUITooltip, TooltipProps as MUITooltipProps } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { useIsMobile } from '@uplift/hooks';
import { useMemo } from 'react';

const DarkTooltip = withStyles(MUITooltip, theme => ({
  tooltip: {
    fontSize: '14px',
    padding: theme.spacing(.5, 1)
  },
}), { name: 'DarkTooltip' });

const LightTooltip = withStyles(DarkTooltip, theme => ({
  arrow: {
    color: theme.palette.common.white,
    '&:before': {
      backgroundColor: theme.palette.common.white,
      boxShadow: theme.shadows[1],
    },
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    color: theme.palette.text.secondary
  },
}), { name: 'LightTooltip' });

export type TooltipProps = MUITooltipProps & {
  light?: boolean;
};

export const Tooltip: React.VFC<TooltipProps> = ({
  light,
  arrow = true,
  enterTouchDelay = 0,
  leaveTouchDelay = 10000,
  ...props
}) => {
  const isMobile = useIsMobile();

  const fixedProps = useMemo(() => ({
    // some design defaults
    arrow,
    placement: isMobile ? 'top' : 'right',
    // for tooltip to work on mobile - https://stackoverflow.com/questions/69030402/material-ui-tooltip-is-not-working-on-mobile
    enterTouchDelay,
    // arbitrary - gives enough time for user to read on mobile, and they can still click away to close
    leaveTouchDelay,
    ...props,
  } as const), [ arrow, enterTouchDelay, isMobile, leaveTouchDelay, props ]);

  if (light) {
    return <LightTooltip {...fixedProps} />;
  }

  return <DarkTooltip {...fixedProps} />;
};
